<template>
  <div class="orderGoods">
    <div class="total">共{{ orderInfo.cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in orderInfo.cartInfo"
        :key="cart.id"
      >
        <div class="pictrue">
          <img :src="cart.productInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            <p>{{ cart.productInfo.attrInfo.suk }}</p>
  			<p v-if="cart.spec_values">{{ cart.spec_values }}</p>
  			<p v-if="cart.student_name">学生姓名：{{cart.student_name}}</p>
          </div>
          <div class="money font-color-red">
            ￥{{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
  			<span v-if="cart.button_status == 1" class="sign signc" @click="sign(cart.contract_url)">签订合同</span>
  			<span v-if="cart.button_status == 2" class="sign signc" @click="sign(cart.contract_url)">续签合同</span>
  			<span v-if="cart.button_status == 3" class="sign chakan" @click="sign(cart.contract_url)">查看合同</span>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail, orderAgain, SignList } from "@api/order";

const NAME = "OrderSign";
export default {
  name: NAME,
  components: {},
  props: {},
  data: function() {
    return {
      id: this.$route.params.id,
      orderInfo: {}
    };
  },
  computed: {},
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getSignList();
      }
    }
  },
  mounted: function() {
    this.getSignList();
  },
  methods: {
	getSignList() {
	  const id = this.id;
	  if (!id) return this.$dialog.error("订单不存在");
	  SignList(id).then(res => {
	      this.orderInfo = res.data;
	    })
	    .catch(err => {
	      this.$dialog.error(err.msg);
	      this.$router.go(-1);
	    });
	},
	sign(contract_url){
		window.location.href = contract_url;
	}
  }
};
</script>
<style scoped>
.orderGoods{
	margin-top: 0;
}
.order-details{
	background-color: #fff;
}
.goodCall {
  color: #e93323;
  text-align: center;
  width: 100%;
  height: 0.86rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.3rem;
  line-height: 0.86rem;
  background: #fff;
}
.iconfont {
  margin-right: 0.15rem;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}

.sign{
	display: inline-block;
	float: right;
	width: 1.5rem;
	height: 0.5rem;
	line-height: 0.5rem;
	text-align: center;
	border-radius: 5px;
}
.signc{
	border: 1px solid #F2443A;
	color: #F2443A;
}
.chakan{
	border: 1px solid #666;
	color: #666;
}
.goodWrapper .item{
	height: auto;
	padding: 0.2rem 0.3rem 0.2rem 0;
}
</style>